import {
    getOrderLogisticsWarningSettings,
    OrderLogisticsWarningSetting,
} from "@/services/api/setting/orderLogisticsWarning";
import { observable, when, makeObservable, actionBound } from "mobx";
import GlobalStore from "@/store";
import { groupBy } from "lodash";
import { axiosGroupByShopType } from "@/services/http/platformAxiosUtil";

class OrderLogisticsWarningStore {
    constructor(public globalStore: typeof GlobalStore) {
        makeObservable(this, {
            loadingMap: observable,
            orderLogisticsWarningSettingMap: observable,
            ensureShopLogisticsWaningSetting: actionBound,
            loadShopLogisticsWaningSetting: actionBound,
        });
    }

    loadingMap = new Map<number, boolean>();

    orderLogisticsWarningSettingMap = new Map<number, OrderLogisticsWarningSetting>();

    async ensureShopLogisticsWaningSetting(shopId: number) {
        const loading = this.loadingMap.get(shopId);

        if (loading) {
            await when(() => loading);
        }

        if (!this.orderLogisticsWarningSettingMap.has(shopId)) {
            await this.loadShopLogisticsWaningSetting([shopId]);
        }

        return this.orderLogisticsWarningSettingMap.get(shopId);
    }

    async loadShopLogisticsWaningSetting(shopIds: number[]) {
        try {
            shopIds.forEach((shopId) => {
                this.loadingMap.set(shopId, true);
            });

            const shopGroupByShopType = groupBy(shopIds, (shopId) =>
                axiosGroupByShopType(this.globalStore.shopMapping.get(shopId).type),
            );
            const groupShopIds = Object.values(shopGroupByShopType);

            for (const group of groupShopIds) {
                const orderLogisticsWarningSettings = await getOrderLogisticsWarningSettings(group);
                orderLogisticsWarningSettings.forEach((orderLogisticsWarningSetting) => {
                    this.orderLogisticsWarningSettingMap.set(
                        orderLogisticsWarningSetting.shopId,
                        orderLogisticsWarningSetting,
                    );
                });
            }
        } finally {
            shopIds.forEach((shopId) => {
                this.loadingMap.set(shopId, false);
            });
        }
    }
}

export default OrderLogisticsWarningStore;
